import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

export const getAllUsers = createAsyncThunk(
  "communityMember/getCommunityMember",

  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.get(
        `/v1/admin/communityMember/get-allUsers`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createDonorMember = createAsyncThunk(
  "donorMember/createCommunityMember",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        `/v1/admin/donorMember/create-donorMember`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getDonorMember = createAsyncThunk(
  "donorMember/getAll",
  async (
    {
      categoryId,
      status = "all",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/donorMember/get-donorMember`,
        {
          params: {
            categoryId,
            status,
            search,
            page: Number(page),
            limit: Number(limit),
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            paginate: paginate === "true",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const deleteDonorMember = createAsyncThunk(
  "donorMember/delete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.delete(
        `/v1/admin/donorMember/delete-donorMember/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteCommityMember = createAsyncThunk(
  "donorMember/undoDelete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/communityMember/undodelete-commityMember/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getDonorMemberByIdData = createAsyncThunk(
  "donorMember/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/donorMember/get_singledonorMember/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateDonorMember = createAsyncThunk(
  "donorMember/update",
  async ({ _id, formData }, thunkAPI) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/donorMember/update_donorMember/${_id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
